import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var qs = require("querystring");

/**
 * Recupera la lista degli studenti che hanno completato un compito specifico
 * @param {string} uname - Username
 * @param {string} token - Token di autenticazione
 * @param {string} idCompito - ID del compito
 * @returns {Promise<Array>} Lista degli studenti con i dettagli del completamento
 */
export default async function getCompitoStudenti(uname, token, idCompito) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "getCompitoStudenti.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        try {
          var body = Buffer.concat(chunks);
          const bodyString = body.toString();
          console.log(
            "🔵 [getCompitoStudenti] Risposta raw dall'API:",
            bodyString
          );

          const resp = JSON.parse(bodyString);
          console.log("🔵 [getCompitoStudenti] Risposta parsata:", resp);

          // Gestisce diversi formati di risposta:
          // 1. Array diretto: [...]
          // 2. {result: "ok", studenti: [...]}
          // 3. {success: true, data: [...]} ← NUOVO FORMATO
          if (Array.isArray(resp)) {
            console.log(
              "✅ [getCompitoStudenti] Array diretto, ritorno:",
              resp.length,
              "studenti"
            );
            resolve(resp);
          } else if (resp.result === "ok" && resp.studenti) {
            console.log(
              "✅ [getCompitoStudenti] Result OK (formato 1), ritorno:",
              resp.studenti.length,
              "studenti"
            );
            resolve(resp.studenti);
          } else if (resp.success === true && resp.data) {
            console.log(
              "✅ [getCompitoStudenti] Success true (formato 2), ritorno:",
              resp.data.length,
              "studenti"
            );
            resolve(resp.data);
          } else {
            console.warn(
              "⚠️ [getCompitoStudenti] Nessuno studente trovato o formato non riconosciuto"
            );
            console.warn("⚠️ [getCompitoStudenti] Risposta ricevuta:", resp);
            // Se non ci sono studenti o errore, ritorna array vuoto
            resolve([]);
          }
        } catch (error) {
          console.error(
            "❌ [getCompitoStudenti] Errore nel parsing della risposta:",
            error
          );
          resolve([]);
        }
      });

      res.on("error", function(error) {
        console.error("Errore nella richiesta getCompitoStudenti:", error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_compito: idCompito,
    });

    console.log("🔵 [getCompitoStudenti] Invio richiesta con:", {
      uname,
      id_compito: idCompito,
      token: token ? "presente" : "mancante",
    });

    req.write(postData);
    req.end();
  });
}
